import { ReactComponent as SchoolaIcon } from "../assets/svg/schoola.svg";
import iTCentralIcon from "../assets/images/itcentral.png";
import TypeSpeed from "../assets/images/typespeed.png";
import Mockraft from "../assets/images/mockraft.png";
import Devlog from "../assets/images/devlog.png";

export const workExperience = [
    {
        company: "Schoola LTD",
        position: "Co-Founder & CTO",
        duration: "2020 - Present",
        description:
            "Schoola is a platform that connects students with tutors for personalized learning experiences. As Co-Founder and CTO, I lead the development of the platform, ensuring a seamless user experience and robust backend architecture.",
        icon: <SchoolaIcon className=" w-12 p-0 m-0 self-center block" />,
        points: [
            "Developed a mobile learning app for students in schools",
            "Rebuilt the backend from monolithic to microservices architecture",
            "Lead the development & design team in implementing new features and maintaining the platform",
            "Implemented CI/CD pipelines for automated testing and deployment",
        ],
    },
    {
        company: "iT Central",
        position: "Mobile Developer",
        duration: "2020 - 2023",
        description: "wee",
        icon: (
            <img
                src={iTCentralIcon}
                alt="it_central_logo"
                className=" w-12 p-0 m-0 self-center block"
            />
        ),
        points: [
            "Built mobile applications for various clients, focusing on user experience and performance",
            "Designed figma prototypes and collaborated with designers to implement UI/UX designs",
            "Worked with cross-functional teams to deliver high-quality software solutions",
        ],
    },
];

export const projects = [
    {
        name: "TypeSpeed",
        description:
            "TypeSpeed is a typing speed test application that allows users to measure their typing speed and accuracy. It features a clean interface and real-time feedback.",
        link: "https://typespeed.abdlim.cloud",
        github: "https://github.com/AbdLim/typespeed",
        image: (
            <img
                src={TypeSpeed}
                alt="typespeed_screenshot"
                className="p-0 m-0 self-center block"
            />
        ),
        tech: ["React", "TypeScript", "Tailwind CSS"],
    },
    {
        name: "Mockraft (building)",
        description:
            "A backend mocking tool that allows developers to create mock APIs for testing and development purposes. It provides a user-friendly interface to define endpoints and responses.",
        link: null,
        github: null,
        image: (
            <img
                src={Mockraft}
                alt="mockraft_screenshot"
                className="p-0 m-0 self-center block"
            />
        ),
        tech: ["React", "TypeScript", "Tailwind CSS", "FastAPI", "PostgreSQL"],
    },
    {
        name: "Devlog (building)",
        description:
            "A personal mobile application for developers to log their daily activities, track progress, and share updates with the community. It aims to enhance productivity and collaboration among developers.",
        link: null,
        github: null,
        image: (
            <img
                src={Devlog}
                alt="devlog_screenshot"
                className="p-0 m-0 self-center block"
            />
        ),
        tech: ["Flutter", "Firebase"],
    },
];
